const TextArea = ({ register, rows, name, placeholder, maxLength }) => {
  return (
    <div className="TextArea">
      <textarea rows={rows} {...register} name={name} placeholder={placeholder} maxLength={maxLength} />
    </div>
  )
}

export default TextArea;